<medrecord-tool-toast></medrecord-tool-toast>
<router-outlet></router-outlet>
